import { string, shape, number, arrayOf } from 'prop-types';
import materialBasicInformationPropTypes from '../../material/proptypes/MaterialPropTypes';

const activityBasicInformationPropTypes = {
  id: number.isRequired,
  companyActivityId: string,
  name: string.isRequired,
  description: string,
  activityType: string.isRequired,
};

const activityMaterialInformationPropTypes = {
  materialList: arrayOf(
    shape({
      material: shape(materialBasicInformationPropTypes),
      quantity: number.isRequired,
    }),
  ),
};

const activityTaskInformationPropTypes = {
  activityTaskList: arrayOf(
    shape({
      description: string.isRequired,
      id: number.isRequired,
      orderDependent: number.isRequired,
      taskOrder: number,
      workingHours: number.isRequired,
    }),
  ),
};

const activityBasicInformationDefaultProps = {
  description: null,
  activityType: null,
  companyActivityId: null,
  factor: null,
  factorType: null,
};

const activityMaterialInformationDefaultProps = [];

export {
  activityBasicInformationPropTypes,
  activityBasicInformationDefaultProps,
  activityMaterialInformationPropTypes,
  activityMaterialInformationDefaultProps,
  activityTaskInformationPropTypes,
};
